import React from 'react'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Navbar'
const index = () => {
  return (
    <div>

      <Header />
      <Footer />
    </div>
  )
}

export default index
